// Imports ------------------------------------------------------------------->

import {Service, service, inject} from "./di";
import {StorageService} from "./StorageService";
import {EventService} from "./EventService";
import {Flyer} from "../definitions/FlyerDefinitions";

// Private Definitions ------------------------------------------------------->

type Favourites = number[];

// Public Definitions -------------------------------------------------------->

@service
export class FavouriteService extends Service {

	@inject storage: StorageService;
	@inject eventService: EventService;

	private _favourites: Favourites = this._loadFavourites();

	addFavourite(flyer: Flyer) {
		this._favourites.push(flyer.merchantId);
		this._saveFavourites();
	}

	removeFavourite(flyer: Flyer) {
		const idx = this._favourites.indexOf(flyer.merchantId);
		if (idx === -1) {
			return;
		}
		this._favourites.splice(idx, 1);
		this._saveFavourites();
	}

	isFavourite(flyer: Flyer) {
		if (!flyer) {
			return false;
		}
		return this._favourites.indexOf(flyer.merchantId) !== -1;
	}

	getFavouriteMerchantIds() {
		return this._favourites;
	}

	private _saveFavourites() {
		this.storage.setItem("favourites", JSON.stringify({
			version: 1,
			favourites: this._favourites
		}));

		this.eventService.fireFavouritesEvent("changed");
	}

	private _loadFavourites() {
		const data = JSON.parse(this.storage.getItem("favourites") || "[]");
		return data.favourites || [];
	}
}
